import(/* webpackMode: "eager", webpackExports: ["HardwareAccordion","WifiBluetoothAccordion"] */ "/vercel/path0/components/hardware-accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImagePlaceholder"] */ "/vercel/path0/components/image-placeholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
